import { Component } from '@angular/core';

import { RouterModule } from '@angular/router';
@Component({
    selector: 'app-tickets',
    templateUrl: './tickets.component.html',
    styleUrl: './tickets.component.css',
    imports: [RouterModule]
})
export class TicketsComponent {

}
